/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Final_SubInputs */

const en_mk_final_sub = /** @type {(inputs: Mk_Final_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 days free, no credit card.`)
};

const id_mk_final_sub = /** @type {(inputs: Mk_Final_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 hari gratis, tanpa kartu kredit.`)
};

/**
* | output |
* | --- |
* | "14 days free, no credit card." |
*
* @param {Mk_Final_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_final_sub = /** @type {((inputs?: Mk_Final_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Final_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_final_sub(inputs)
	return en_mk_final_sub(inputs)
});